/*!
 * doTERRA CRM
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React from "react";
import { useJson } from "../../shared/utils/json";
import { WindowProvider } from "../../shared/contexts/window";
import { PageProvider } from "../../shared/contexts/page";
import { PaymentsProvider } from "../../shared/contexts/payments";
import { CustomerProvider } from "../../shared/contexts/customer";
import { PaymentView } from "../../shared/containers/payment-view";
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";


const ProfilePayments = (props) => {
    const { model, markets } = props;
    const cardMessage = model.creditCardMessage;
    const runEnv = model.digitalWalletRunEnvironment;
    const googlePayMerchantId = model.googlePayMerchantId;
    // NOTE: when PageProvider is propagated forward (as to the whole page), we can replace the following line with a state variable from PageProvider
    const brainTreeToken = model.clientToken;
    // NOTE: when SiteProvider is propagated forward (as to the whole page), we can replace the following line with a state variable from SiteProvider
    const addPaymentInitialState = window.location.search.includes("addAPayment");

    return (
        <PaymentView markets={markets} initialMode={addPaymentInitialState ? 'addAPayment' : 'list'} citMitMessage={cardMessage} digitalWalletEnv={runEnv} googlePayMerchantId={googlePayMerchantId} brainTreeToken={brainTreeToken} recaptchaKey={model.recaptchaKey}/>
    );
};

const ProfilePaymentsContainer = (props) => {
    const { parseJson } = useJson();
    const model = parseJson(props.model);
    const markets = props.markets;
    const customerId = model.customerId = model.uid;
    const activePaymentMethods = model.activePaymentMethods || 'card';

    return (
        <WindowProvider>
            <PageProvider>
                <CustomerProvider uid={model.uid} customerId={customerId} language={model.language} hasActiveLrp={model.hasActiveLrp} orderType={model.orderType}>
                    <PaymentsProvider context='profile' activePaymentMethods={activePaymentMethods} ccNonce={model.ccNonce}>
                        <ProfilePayments model={model} markets={markets}/>
                    </PaymentsProvider>
                </CustomerProvider>
            </PageProvider>
        </WindowProvider>
    );
};

const domContainer = document.querySelector('#profile-payment-container');
if (domContainer){
  const markets = getAndStripAttribute('data-markets', domContainer);
  const model = getAndStripAttribute('data-model', domContainer);
  const root = createRoot(domContainer);
  root.render(<ProfilePaymentsContainer markets={markets} model={model}/>);
}

